module.exports = __webpack_public_path__ + "img/hot1.b7b9987c.jpg";